export * from './job-pharma-animals-placeholder-table.component';
export * from './job-pharma-animals-cohorts-table.component';
export * from './job-pharma-animals-individual-table.component';
export * from './samples-individual-table/job-pharma-samples-individual-table.component';
export * from './samples-group-table/job-pharma-samples-groups-table.component';
export * from './job-pharma-tasks-inputs-table.component';
export * from './job-pharma-tasks-list-table.component';
export * from './job-pharma-tasks-outline-table.component';
export * from './job-pharma-tasks-schedule-table.component';
